import User from "./user";
import { UserSettings, defaultTaskOrder } from "./user-settings";

const defaultUserSettings = new UserSettings(false, defaultTaskOrder);

export class Session {
  constructor(
    public user: User | null = null,
    public userSettings: UserSettings = defaultUserSettings,
    public readonly sessionStart: number = Date.now()
  ) {}

  endSession() {
    this.user = null;
    this.userSettings = defaultUserSettings;
  }
}
